import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

const aiActions = defineAIActions({
  namespace: 'competitor',
  actions: [
    {
      id: 'analyze',
      name: '分析竞品',
      description: '深度分析竞品账号的内容策略和表现',
      parameters: [
        { name: 'competitorId', type: 'number', description: '竞品ID', required: true },
      ],
      handler: async (params) => {
        return {
          type: 'report',
          data: {
            contentStyle: '护肤科普为主，穿插产品推荐',
            postFrequency: '每周3-4篇',
            engagementRate: 5.2,
          },
          message: '竞品分析完成',
        };
      },
    },
    {
      id: 'compare',
      name: '对比竞品',
      description: '对比多个竞品账号数据',
      parameters: [
        { name: 'competitorIds', type: 'array', description: '竞品ID列表', required: true },
      ],
      handler: async (params) => {
        return {
          type: 'table',
          data: [],
          message: '对比分析完成',
        };
      },
    },
    {
      id: 'find-similar',
      name: '发现相似账号',
      description: '发现与指定账号风格相似的竞品',
      parameters: [
        { name: 'accountId', type: 'number', description: '参考账号ID', required: true },
      ],
      handler: async () => {
        return {
          type: 'list',
          data: [],
          message: '发现了5个相似账号',
        };
      },
    },
  ],
});

export default definePlugin({
  meta: {
    name: 'competitor-analyzer',
    version: '1.0.0',
    displayName: '竞品分析',
    description: '竞品账号监控、内容分析、策略参考',
    icon: 'search',
    category: 'intelligence',
  },

  onLoad: async () => {
    console.log('[Plugin] Competitor Analyzer loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Competitor Analyzer unloaded');
  },

  routes: [
    {
      path: '/competitors',
      lazy: async () => {
        const { CompetitorList } = await import('./pages/CompetitorList');
        return { Component: CompetitorList };
      },
    },
    {
      path: '/competitors/new',
      lazy: async () => {
        const { CompetitorAdd } = await import('./pages/CompetitorAdd');
        return { Component: CompetitorAdd };
      },
    },
    {
      path: '/competitors/:id',
      lazy: async () => {
        const { CompetitorDetail } = await import('./pages/CompetitorDetail');
        return { Component: CompetitorDetail };
      },
    },
    {
      path: '/competitors/compare',
      lazy: async () => {
        const { CompetitorCompare } = await import('./pages/CompetitorCompare');
        return { Component: CompetitorCompare };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'competitors',
      title: '竞品分析',
      icon: 'search',
      path: '/competitors',
      order: 6,
    },
  ],

  aiActions,
});

